module.exports = __webpack_public_path__ + "media/packs/images/flags/GA-4f5988f0620a7a76769f7cb7b7624048.svg";